import React from 'react';
import { COUNTRIES } from '../constants/Countries';

interface CountrySelectProps {
    value?: string | null;
    onChange: (country: string | null) => void;
    onBlur?: () => void;
    label?: string;
    placeholder?: string;
    showFlags?: boolean;
    disabled?: boolean;
    className?: string;
}

const CountrySelect: React.FC<CountrySelectProps> = ({
                                                         value,
                                                         onChange,
                                                         onBlur,
                                                         placeholder = ('Select a country') as string,
                                                         showFlags = false,
                                                         disabled = false,
                                                         className = '',
                                                     }) => {
    const selectedCountry = value ? COUNTRIES.find(country => country.label === value) || null : null;

    return (
        <div className={`relative w-full ${className}`}>
            <select
                className="w-full px-3 py-2 border border-input bg-background rounded-md text-sm ring-offset-background focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                value={selectedCountry?.label || ''}
                onChange={(e) => {
                    const country = COUNTRIES.find(c => c.label === e.target.value);
                    onChange(country?.label || null);
                }}
                onBlur={onBlur}
                disabled={disabled}
            >
                <option value="">{placeholder}</option>
                {COUNTRIES.map((country) => (
                    <option key={country.code} value={country.label}>
                        {country.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default CountrySelect;
